import firebase from "firebase/app"
import "firebase/firestore"
import "firebase/auth"
import "firebase/storage"
import helpers from "./lib/helpers"

const config = {
  //apiKey: process.env.REACT_APP_FB_APIKEY,
  apiKey: helpers.getEnv(),
  authDomain: process.env.REACT_APP_FB_AUTHDOMAIN,
  projectId: process.env.REACT_APP_FB_PROJECTID,
  storageBucket: process.env.REACT_APP_FB_STORBUCKET,
}

var theApp = firebase.initializeApp(config);

const dtg = firebase.firestore().collection("Tenants")
const storage = firebase.storage()

export {firebase, dtg, storage}
